<div class="table-wrapper">
  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-container">
    <qai-loading [size]="'medium'"></qai-loading>
  </div>  

  <ng-container *ngIf="!isLoading">
    <!-- Status filter -->
    <div class="filter-container">
      <qai-searchable-select
        [shape]="'rectangle'"
        [placement]="'below-start'"
        [offset]="4"
        [placeholder]="'Assignment status'"
        [searchable]="false"
        [options]="statusOptions"
        [multiselect]="true"
        [value]="selectedStatusValues"
        [disabled]="hasNoAssignments"
        (valueChange)="onStatusFilterChange($event)"
        [selectionPrefix]="'Assignment status:'"
        [scopedOptionsSelectionMode]="visibleOptionsSelectionMode"
      >
      </qai-searchable-select>
    </div>
  </ng-container>

  <!-- Empty State -->
  <div *ngIf="!isLoading && tableData.length === 0" class="empty-container">
    <p>No Assignments found</p>
  </div>

  <!-- Data Loaded State -->
  <qai-table
    *ngIf="!isLoading && tableData.length > 0"
    [headers]="headers"
    [data]="tableData"
    [striped]="false"
    [currentPage]="currentPage"
    [initialSortColumn]="initialSortColumn"
    [initialSortDirection]="initialSortDirection"
    (rowAction)="onTableRowAction($event)"
    (rowClick)="onTableRowClick($event)"
    (pageChanged)="onPageChanged($event)"
  ></qai-table>
</div>